export const translations = {
  el: {
    nav: {
      home: 'Αρχική',
      about: 'Σχετικά',
      gallery: 'Γκαλερί',
      testimonials: 'Κριτικές',
      contact: 'Επικοινωνία',
    },
    hero: {
      tagline: 'Η Γεύση του viral',
      subtitle: 'Viral French Fruit Desserts',
      description: 'Ανακαλύψτε τη μαγεία των trompe-l\'œil fruit desserts - γλυκά που μοιάζουν με φρούτα αλλά κρύβουν μια εκπληκτική γεύση',
      cta: 'Ανακαλύψτε τα Γλυκά μας',
      location: 'Βρείτε μας',
    },
    about: {
      title: 'Η Ιστορία της Μάγιας',
      subtitle: 'Πάθος, Δημιουργικότητα & Γεύση',
      story: 'Στον κόσμο των social media, όπου το επόμενο viral γεννιέται μερικές ώρες και το προηγούμενο χάνεται με την ταχύτητα του scroll, λίγοι προλαβαίνουν να το καταλάβουν και ακόμη λιγότεροι να το ξεπεράσουν.',
      quote: 'Η επιτυχία δεν είναι τύχη, είναι στρατηγική. Παρακολουθώ τις τάσεις αλλά κάθε επιχείρηση που θέλει να είναι μπροστά πρέπει να έχει τη δική της ταυτότητα και αυθεντικότητα.',
      quoteAuthor: '— Μάγια Παναγή',
      experience: 'Δεκαετής Εμπειρία',
      experienceDesc: 'στη ζαχαροπλαστική',
      quality: 'Ποιότητα & Αγάπη',
      qualityDesc: 'σε κάθε δημιουργία',
      viral: 'Viral Επιτυχία',
      viralDesc: 'σε όλη την Κύπρο',
      magazineAlt: 'Maya\'s Flavours στο περιοδικό',
    },
    gallery: {
      title: 'Οι Δημιουργίες μας',
      subtitle: 'Κάθε γλυκό είναι ένα έργο τέχνης',
    },
    testimonials: {
      title: 'Τι Λένε οι Πελάτες μας',
      subtitle: 'Εμπειρίες που μιλούν από μόνες τους',
    },
    contact: {
      title: 'Επικοινωνήστε μαζί μας',
      subtitle: 'Θα χαρούμε να σας εξυπηρετήσουμε',
      phone: 'Τηλέφωνο',
      location: 'Τοποθεσία',
      locationText: 'Λατσιά, Κύπρος',
      hours: 'Ώρες Λειτουργίας',
      findUs: 'Βρείτε μας στο χάρτη',
      followUs: 'Ακολουθήστε μας',
      tapToCall: 'Πατήστε για κλήση',
      monSat: 'Δευτέρα - Σάββατο',
      saturday: 'Σάββατο',
      sunday: 'Κυριακή',
      closed: 'Κλειστά',
    },
    footer: {
      tagline: 'Η Γεύση του viral',
      menu: 'Μενού',
      rights: 'Με επιφύλαξη παντός δικαιώματος',
      madeWith: 'Φτιαγμένο με',
      inCyprus: 'στην Κύπρο',
      designedBy: 'Σχεδιασμός & Ανάπτυξη από',
    },
  },
  en: {
    nav: {
      home: 'Home',
      about: 'About',
      gallery: 'Gallery',
      testimonials: 'Reviews',
      contact: 'Contact',
    },
    hero: {
      tagline: 'The Taste of Viral',
      subtitle: 'Viral French Fruit Desserts',
      description: 'Discover the magic of trompe-l\'œil fruit desserts - sweets that look like fruits but hide an amazing taste',
      cta: 'Discover Our Sweets',
      location: 'Find Us',
    },
    about: {
      title: 'Maya\'s Story',
      subtitle: 'Passion, Creativity & Taste',
      story: 'In the world of social media, where the next viral is born in a few hours and the previous one is lost at the speed of scroll, few manage to understand it and even fewer to surpass it.',
      quote: 'Success is not luck, it\'s strategy. I follow trends but every business that wants to be ahead must have its own identity and authenticity.',
      quoteAuthor: '— Maya Panayi',
      experience: 'Decade of Experience',
      experienceDesc: 'in pastry making',
      quality: 'Quality & Love',
      qualityDesc: 'in every creation',
      viral: 'Viral Success',
      viralDesc: 'across Cyprus',
      magazineAlt: 'Maya\'s Flavours in magazine',
    },
    gallery: {
      title: 'Our Creations',
      subtitle: 'Every sweet is a work of art',
    },
    testimonials: {
      title: 'What Our Customers Say',
      subtitle: 'Experiences that speak for themselves',
    },
    contact: {
      title: 'Contact Us',
      subtitle: 'We\'d love to serve you',
      phone: 'Phone',
      location: 'Location',
      locationText: 'Latsia, Cyprus',
      hours: 'Opening Hours',
      findUs: 'Find us on the map',
      followUs: 'Follow us',
      tapToCall: 'Tap to call',
      monSat: 'Monday - Saturday',
      saturday: 'Saturday',
      sunday: 'Sunday',
      closed: 'Closed',
    },
    footer: {
      tagline: 'The Taste of Viral',
      menu: 'Menu',
      rights: 'All rights reserved',
      madeWith: 'Made with',
      inCyprus: 'in Cyprus',
      designedBy: 'Designed & Developed by',
    },
  },
};
